module.exports = __webpack_public_path__ + "img/redcross550x450.2bb93284.png";